import {getLocal, setLocal} from "@/utils/storage";
import {showMessage} from "@/utils";
import {greatReply} from "@/api/community/reply";
import {toggleWorkFavorite, getFavorites, greatWork} from "@/api/community/works";
import {getIdols, greatUser, toggleFollow} from "@/api/community/zone";

export const GREAT_NAMES = {
    state: {
        users:              'users',
        works:              'works',
        replies:            'replies',
        idols:              'idols',
        favorites:          'favorites'
    },
    mutations: {
        GREAT_USERS:        'GREAT_USERS',
        GREAT_WORKS:        'GREAT_WORKS',
        GREAT_REPLIES:      'GREAT_REPLIES',
        SET_IDOLS:          'SET_IDOLS',
        SET_FAVORITES:      'SET_FAVORITES',
    },
    actions: {
        greatUsers:         'greatUsers',
        greatWorks:         'greatWorks',
        greatReplies:       'greatReplies',
        loadFavorites:      'loadFavorites',
        toggleFollow:       'toggleFollow',
        loadIdols:          'loadIdols',
        toggleFavorites:    'toggleFavorites'
    }
};

const initializeState = {
    [GREAT_NAMES.state.users]:      getLocal(GREAT_NAMES.state.users) || [],
    [GREAT_NAMES.state.works]:      getLocal(GREAT_NAMES.state.works) || [],
    [GREAT_NAMES.state.replies]:    getLocal(GREAT_NAMES.state.replies) || [],
    [GREAT_NAMES.state.idols]:      getLocal(GREAT_NAMES.state.idols) || [],
    [GREAT_NAMES.state.favorites]:  getLocal(GREAT_NAMES.state.favorites) || []
};

function checkGreat(array, id) {
    if (array.some(item => item === id)) {
        showMessage("你已经赞过啦");
        return false;
    }
    return true;
}

const great = {
    state: Object.assign({}, initializeState),
    getters: {
        [GREAT_NAMES.state.users]:      state => state[GREAT_NAMES.state.users],
        [GREAT_NAMES.state.works]:      state => state[GREAT_NAMES.state.works],
        [GREAT_NAMES.state.replies]:    state => state[GREAT_NAMES.state.replies],
        [GREAT_NAMES.state.idols]:      state => state[GREAT_NAMES.state.idols],
        [GREAT_NAMES.state.favorites]:  state => state[GREAT_NAMES.state.favorites]
    },
    mutations: {
        [GREAT_NAMES.mutations.GREAT_USERS]: (state, uid) => {
            state.users.push(uid);
            setLocal(GREAT_NAMES.state.users, state.users);
        },
        [GREAT_NAMES.mutations.GREAT_WORKS]: (state, pwid) => {
            state.works.push(pwid);
            setLocal(GREAT_NAMES.state.works, state.works);
        },
        [GREAT_NAMES.mutations.GREAT_REPLIES]: (state, rid) => {
            state.replies.push(rid);
            setLocal(GREAT_NAMES.state.replies, state.replies);
        },
        [GREAT_NAMES.mutations.SET_IDOLS]: (state, idols) => {
            state.idols = idols;
            setLocal(GREAT_NAMES.state.idols, idols);
        },
        [GREAT_NAMES.mutations.SET_FAVORITES]: (state, favorites) => {
            state.favorites = favorites;
            setLocal(GREAT_NAMES.state.favorites, favorites);
        }
    },
    actions: {
        async [GREAT_NAMES.actions.greatUsers]({commit, state}, uid) {
            if (checkGreat(state[GREAT_NAMES.state.users], uid)) {
                let res = await greatUser(uid);
                commit(GREAT_NAMES.mutations.GREAT_USERS, uid);
                return Promise.resolve(res);
            }
            return Promise.reject();
        },
        async [GREAT_NAMES.actions.greatWorks]({commit, state}, pwid) {
            if (checkGreat(state[GREAT_NAMES.state.works], pwid)) {
                let res = await greatWork(pwid);
                commit(GREAT_NAMES.mutations.GREAT_WORKS, pwid);
                return Promise.resolve(res);
            }
            return Promise.reject();
        },
        async [GREAT_NAMES.actions.greatReplies]({commit, state}, rid) {
            if (checkGreat(state[GREAT_NAMES.state.replies], rid)) {
                let res = await greatReply(rid);
                commit(GREAT_NAMES.mutations.GREAT_REPLIES, rid);
                return Promise.resolve(res);
            }
            return Promise.reject();
        },
        async [GREAT_NAMES.actions.loadIdols]({commit}) {
            let {data} = await getIdols();
            commit(GREAT_NAMES.mutations.SET_IDOLS, data);
        },
        async [GREAT_NAMES.actions.toggleFollow]({dispatch}, uid) {
            await toggleFollow(uid);
            await dispatch(GREAT_NAMES.actions.loadIdols);
        },
        async [GREAT_NAMES.actions.loadFavorites]({commit}) {
            let {data} = await getFavorites();
            commit(GREAT_NAMES.mutations.SET_FAVORITES, data);
        },
        async [GREAT_NAMES.actions.toggleFavorites]({dispatch}, pwid) {
            await toggleWorkFavorite(pwid);
            await dispatch(GREAT_NAMES.actions.loadFavorites);
        }
    }
};

export default great;
